import React from 'react';
import { FaTag } from 'react-icons/fa';
import { formatPrice, getUnitSingularForm } from './pricingUtils';

const CenowkaInlineEditor = ({
  product,
  cenowkaEditData,
  setCenowkaEditData,
  handleSaveCenowka,
  handleCancelCenowkaEdit,
  addToBuffer,
  editingCenowkaProductId,
  canPrintLabels,
  // Calculator
  showPriceCalculator,
  setShowPriceCalculator,
  calculatedPrices,
  setPriceFromCalculator,
  // Get filtered products for buffer
  getFilteredProducts,
}) => {
  return (
    <div style={{
      padding: '0.75rem',
      backgroundColor: 'var(--warning-light)',
      border: '1px solid var(--warning)',
      borderRadius: '4px'
    }}>
      {/* Nagłówek */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '0.5rem',
        paddingBottom: '0.5rem',
        borderBottom: '1px solid var(--border)'
      }}>
        <FaTag style={{ color: 'var(--warning)', marginRight: '6px' }} />
        <span style={{ fontWeight: '600', fontSize: '12px', color: 'var(--text-secondary)' }}>
          Edycja cenówki - {product.nazwa_uproszczona || product.nazwa}
        </span>
      </div>

      {/* Pola formularza w 3 kolumnach */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem' }}>
        {/* Kolumna 1 */}
        <div>
          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Nazwa uproszczona *
          </label>
          <input
            type="text"
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
            value={cenowkaEditData.nazwa_uproszczona}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, nazwa_uproszczona: e.target.value })}
            placeholder="Skrócona nazwa"
          />

          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px', marginTop: '6px' }}>
            Cena specjalna *
          </label>
          <input
            type="number"
            step="0.01"
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
            value={cenowkaEditData.cena_cenowkowa}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, cena_cenowkowa: e.target.value })}
            placeholder="0.00"
          />

          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px', marginTop: '6px' }}>
            Ilość / Jednostka
          </label>
          <div style={{ display: 'flex', gap: '4px' }}>
            <input
              type="number"
              step="0.001"
              style={{ flex: 1, padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
              value={cenowkaEditData.waga || ''}
              onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, waga: e.target.value })}
              placeholder="0"
            />
            <select
              style={{ width: '60px', padding: '5px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '10px', height: '28px' }}
              value={cenowkaEditData.jednostka_wagi || 'nieustawiono'}
              onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, jednostka_wagi: e.target.value })}
            >
              <option value="nieustawiono">{'—'}</option>
              <option value="gramy">gr</option>
              <option value="ml">ml</option>
              <option value="tabletki">tab</option>
              <option value="kapsułki">kaps</option>
              <option value="sztuki">szt</option>
            </select>
          </div>
        </div>

        {/* Kolumna 2 */}
        <div>
          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Cena promocyjna
          </label>
          <input
            type="number"
            step="0.01"
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
            value={cenowkaEditData.cena_promocyjna}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, cena_promocyjna: e.target.value })}
            placeholder="0.00"
          />

          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px', marginTop: '6px' }}>
            Typ cenówki
          </label>
          <select
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
            value={cenowkaEditData.typ_cenowki}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, typ_cenowki: e.target.value })}
          >
            <option value="standardowa">Standardowa</option>
            <option value="promocyjna">Promocyjna</option>
            <option value="wyprzedaz">Wyprzedaż</option>
          </select>

          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px', marginTop: '6px' }}>
            Producent
          </label>
          <input
            type="text"
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', height: '28px' }}
            value={cenowkaEditData.kategoria_cenowki}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, kategoria_cenowki: e.target.value })}
            placeholder="Producent"
          />
        </div>

        {/* Kolumna 3 */}
        <div>
          <label style={{ display: 'block', fontSize: '10px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>
            Opis
          </label>
          <textarea
            style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', resize: 'none' }}
            rows="3"
            value={cenowkaEditData.opis_cenowki}
            onChange={(e) => setCenowkaEditData({ ...cenowkaEditData, opis_cenowki: e.target.value })}
            placeholder="Opis cenówki"
          />
        </div>
      </div>

      {/* Sekcja kalkulatora cen per 100g/per kapsułka */}
      {cenowkaEditData.waga && parseFloat(cenowkaEditData.waga) > 0 && (
        <div style={{
          marginTop: '0.5rem',
          padding: '0.5rem',
          background: 'var(--info-light)',
          borderRadius: '4px',
          border: '1px solid var(--info-light)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <span style={{ fontSize: '10px', fontWeight: '600', color: 'var(--info)' }}>
              {'📊'} Kalkulator cen per jednostkę
            </span>
            <button
              type="button"
              style={{
                background: 'none',
                border: '1px solid var(--info)',
                fontSize: '11px',
                padding: '4px 10px',
                color: 'var(--info)'
              }}
              onClick={() => setShowPriceCalculator(!showPriceCalculator)}
            >
              {showPriceCalculator ? 'Ukryj' : 'Pokaż'}
            </button>
          </div>
          {showPriceCalculator && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
              {/* Obliczone ceny */}
              <div style={{
                padding: '0.5rem',
                background: 'var(--card-bg)',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Obliczone:</div>
                {(cenowkaEditData.jednostka_wagi === 'gramy' || cenowkaEditData.jednostka_wagi === 'ml') && calculatedPrices.per100g > 0 && (
                  <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--success)' }}>
                    {calculatedPrices.per100g.toFixed(2)} zł / 100{cenowkaEditData.jednostka_wagi === 'gramy' ? 'g' : 'ml'}
                  </div>
                )}
                {(cenowkaEditData.jednostka_wagi === 'tabletki' || cenowkaEditData.jednostka_wagi === 'kapsułki' || cenowkaEditData.jednostka_wagi === 'sztuki') && calculatedPrices.perUnit > 0 && (
                  <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--success)' }}>
                    {formatPrice(calculatedPrices.perUnit, 3)} zł / {getUnitSingularForm(cenowkaEditData.jednostka_wagi)}
                  </div>
                )}
              </div>

              {/* Ustaw cenę */}
              <div style={{ padding: '0.25rem' }}>
                {(cenowkaEditData.jednostka_wagi === 'gramy' || cenowkaEditData.jednostka_wagi === 'ml') && (
                  <div>
                    <div style={{ display: 'flex', gap: '3px', marginBottom: '3px' }}>
                      <input type="number" step="0.01"
                        placeholder={`zł/100${cenowkaEditData.jednostka_wagi === 'gramy' ? 'g' : 'ml'}`}
                        id="price-per-100"
                        style={{ flex: 1, padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '10px', height: '24px' }} />
                      <input type="number" step="0.001" placeholder="waga" id="target-weight-grams"
                        style={{ width: '50px', padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '10px', height: '24px' }} />
                      <button type="button"
                        style={{ padding: '4px 10px', border: '1px solid var(--info)', color: 'var(--info)' , fontSize: '11px', cursor: 'pointer' }}
                        onClick={() => {
                          const unitPrice = document.getElementById('price-per-100').value;
                          const targetWeight = document.getElementById('target-weight-grams').value;
                          if (unitPrice && targetWeight) setPriceFromCalculator(unitPrice, targetWeight);
                        }}>
                        Ustaw
                      </button>
                    </div>
                  </div>
                )}
                {(cenowkaEditData.jednostka_wagi === 'tabletki' || cenowkaEditData.jednostka_wagi === 'kapsułki' || cenowkaEditData.jednostka_wagi === 'sztuki') && (
                  <div>
                    <div style={{ display: 'flex', gap: '3px', marginBottom: '3px' }}>
                      <input type="number" step="0.001"
                        placeholder={`zł/${getUnitSingularForm(cenowkaEditData.jednostka_wagi)}`}
                        id="price-per-unit"
                        style={{ flex: 1, padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '10px', height: '24px' }} />
                      <input type="number" step="1" placeholder="ilość" id="target-count-units"
                        style={{ width: '50px', padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '10px', height: '24px' }} />
                      <button type="button"
                        style={{ padding: '4px 10px', border: '1px solid var(--info)', color: 'var(--info)' , fontSize: '11px', cursor: 'pointer' }}
                        onClick={() => {
                          const unitPrice = document.getElementById('price-per-unit').value;
                          const targetCount = document.getElementById('target-count-units').value;
                          if (unitPrice && targetCount) setPriceFromCalculator(unitPrice, targetCount);
                        }}>
                        Ustaw
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Przyciski akcji */}
      <div style={{
        display: 'flex',
        gap: '6px',
        marginTop: '0.5rem',
        paddingTop: '0.5rem',
        borderTop: '1px solid var(--border)'
      }}>
        <button type="button"
          style={{
            padding: '4px 10px', border: '1px solid var(--success)', color: 'var(--success)', fontSize: '11px', fontWeight: '500',
            display: 'flex', alignItems: 'center', gap: '4px'
          }}
          onClick={handleSaveCenowka}>
          <FaTag /> Zapisz
        </button>
        {canPrintLabels && (
          <button type="button"
            style={{
              padding: '4px 10px', color: 'var(--warning)',
              border: '1px solid var(--warning)', fontSize: '11px',
              fontWeight: '500', display: 'flex', alignItems: 'center', gap: '4px'
            }}
            onClick={() => {
              const productForBuffer = getFilteredProducts().find(p => p.id === editingCenowkaProductId);
              if (productForBuffer) {
                addToBuffer(productForBuffer, cenowkaEditData);
              }
            }}
            title="Dodaj do bufora">
            <FaTag /> Bufor
          </button>
        )}
        <button type="button"
          style={{
            padding: '4px 10px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)', fontSize: '11px'
          }}
          onClick={handleCancelCenowkaEdit}>
          Anuluj
        </button>
      </div>
    </div>
  );
};

export default CenowkaInlineEditor;
